module.exports = __webpack_public_path__ + "static/media/meghna2.8786097a.png";